<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>确定入库</span>
            <div style="float: right;">
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i>返回
              </el-button>
            </div>
          </div>
          <div>
            <el-row>
              <el-col :span="6">
                <el-form-item label="工单编码：">
                  <span>{{doAllocationOrderInfo.orderId}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请人:">
                  <span>{{doAllocationOrderInfo.staffName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请时间:">
                  <span>{{doAllocationOrderInfo.createTime}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单状态:">
                  <span>{{doAllocationOrderInfo.stateName}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="源商铺：">
                  <span>{{doAllocationOrderInfo.shopName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="源仓库:">
                  <span>{{doAllocationOrderInfo.srcShName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="目标商铺:">
                  <span>{{doAllocationOrderInfo.targetShopName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="目标仓库:">
                  <span>{{doAllocationOrderInfo.targetShName}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="审核备注:">
                  <span>{{doAllocationOrderInfo.stateRemark}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>商品信息</span>
          </div>
          <el-table :data="doAllocationOrderInfo.inoutOrderProducts" border style="width: 100%">
            <el-table-column prop="index" label="序号" width="100" align="center">
              <template slot-scope="scope">
                {{scope.$index + 1}}
              </template>
            </el-table-column>
            <el-table-column prop="productId" label="商品编号" align="center"></el-table-column>
            <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="specName" label="规格" align="center"></el-table-column>
            <el-table-column prop="productCount" label="申请单数量" align="center"></el-table-column>
            <el-table-column label="实际数量" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.actCount" type="number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="金额" align="center"></el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right;">
            <el-button type="warning" style="margin-right: 20px;" @click="_doCancelOrder">
              <i class="el-icon-close"></i>取消入库单
            </el-button>
            <el-button type="primary" @click="doInoutOrder">
              <i class="el-icon-check"></i>确定入库
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { getDict } from '@/api/shop/shopApi'
import { queryProduct, warehousingAllocationOrder } from '@/api/goods/doAllocationOrderInApi'

export default {
  data() {
    return {
      shopId: '',
      doAllocationOrderInfo: {
        orderId: '',
        stateName: '',
        state: '',
        staffId: '',
        staffName: '',
        createTime: '',
        remark: '',
        stateRemark: '',
        shopId: '',
        shopName: '',
        srcShId: '',
        srcShName: '',
        targetShId: '',
        targetShName: '',
        targetShopId: '',
        targetShopName: '',
        productCount: '',
        prodName: '',
        specName: '',
        specId: '',
        productId: '',
        actCount: '',
        inoutOrderProducts: []
      }
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(getDict)
    this._initMethod()
  },
  methods: {
    _initMethod() {
      const orderId = this.$route.query.orderId
      if (!orderId) {
        this.$message.error('非法操作')
        this._goBack()
        return
      }
      
      this.doAllocationOrderInfo.orderId = this.$route.query.orderId
      this.doAllocationOrderInfo.staffName = this.$route.query.staffName
      this.doAllocationOrderInfo.stateName = this.$route.query.stateName
      this.doAllocationOrderInfo.createTime = this.$route.query.createTime
      this.doAllocationOrderInfo.stateRemark = this.$route.query.stateRemark
      this.doAllocationOrderInfo.shopName = this.$route.query.shopName
      this.doAllocationOrderInfo.srcShName = this.$route.query.srcShName
      this.doAllocationOrderInfo.targetShopName = this.$route.query.targetShopName
      this.doAllocationOrderInfo.targetShName = this.$route.query.targetShName
      this.doAllocationOrderInfo.shopId = this.$route.query.shopId
      this.doAllocationOrderInfo.specId = this.$route.query.specId
      this.doAllocationOrderInfo.productId = this.$route.query.productId
      this.doAllocationOrderInfo.productCount = this.$route.query.productCount
      this.doAllocationOrderInfo.actCount = this.$route.query.productCount
      this.doAllocationOrderInfo.state = this.$route.query.state
      this.doAllocationOrderInfo.targetShId = this.$route.query.targetShId
      this.doAllocationOrderInfo.srcShId = this.$route.query.srcShId
      this.doAllocationOrderInfo.targetShopId = this.$route.query.targetShopId
      this.doAllocationOrderInfo.staffId = this.$route.query.staffId
      this.doAllocationOrderInfo.prodName = this.$route.query.prodName
      
      this._listInoutOrderProduct()
    },
    async _listInoutOrderProduct() {
      try {
        const param = {
          page: 1,
          row: 50,
          specId: this.doAllocationOrderInfo.specId,
          productId: this.doAllocationOrderInfo.productId,
          shopId: this.doAllocationOrderInfo.shopId
        }
        const res = await queryProduct(param)
        this.doAllocationOrderInfo.inoutOrderProducts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async doInoutOrder() {
      try {
        this.doAllocationOrderInfo.state = "4004"
        const res = await warehousingAllocationOrder(this.doAllocationOrderInfo)
        if (res.code === 0) {
          this.$message.success("入库成功")
          this._goBack()
        }
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    async _doCancelOrder() {
      try {
        this.doAllocationOrderInfo.state = "3003"
        const res = await warehousingAllocationOrder(this.doAllocationOrderInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-col {
  width: 100%;
}
</style>